import { useEffect } from "react";
import * as ISchema from "../../src/__schema__";
import { useAllFeatureFlags } from "../launch-darkly/useLaunchDarkly";
import { getBulkExperiments } from "../util/experiment.util";
import { PostMessageManager } from "../util/post-message.util";
// Handles the old way of sending experiments and feature flags to the extension
export const useSendExperimentsAndFeatureFlags = (org: ISchema.IOrg | null) => {
  const { launchDarklyFlags } = useAllFeatureFlags();

  useEffect(() => {
    const bulkExperiments = getBulkExperiments();

    const oldExperimentsAndLaunchDarklyFlags = {
      ...bulkExperiments,
      ...launchDarklyFlags,
    };

    PostMessageManager.sendExperiments(oldExperimentsAndLaunchDarklyFlags);
  }, [org?.experiments, launchDarklyFlags]);
};
